/* HARMONY — Ver o caimento
   Portado do protótipo (harmony-prototype.html, "VER O CAIMENTO"), com uma
   mudança de arquitetura: a ficha do modelo (FIT_DATA, um objeto JS com
   todos os produtos) virou metafields do produto, renderizados direto pelo
   Liquid em snippets/fit-modal.liquid — não precisa de lookup em JS.

   O que continua em localStorage, de propósito: a altura/peso que o
   PRÓPRIO VISITANTE informa. No protótipo isso vivia atrás de login
   (Virtual Try-On); aqui não existe sistema de conta real ainda, então fica
   por dispositivo, sem conta. Quando a loja tiver Shopify Customer
   Accounts, troque savedMeasures()/save() por leitura/escrita em
   customer.metafields.custom.height_cm / weight_kg via Customer Account
   API, pra acompanhar a pessoa entre aparelhos — não é seguro nem
   sincroniza hoje, é só conveniência local. */
window.HARMONY_FIT = (function () {
  var STORAGE_KEY = 'hmy_measures';
  var SIZES = ['P', 'M', 'G', 'GG', 'XG'];

  function fmtHeight(cm) {
    if (!cm) return '—';
    return (cm / 100).toFixed(2).replace('.', ',') + ' m';
  }

  /* Recomendação pra modelagem OVERSIZED: o peso manda (circunferência do
     tronco), a altura ajusta o comprimento. Faixas conservadoras de
     propósito — na dúvida a peça sobra, não aperta. */
  function recommend(heightCm, weightKg) {
    if (!weightKg) return null;
    var i;
    if (weightKg < 58) i = 0;
    else if (weightKg < 70) i = 1;
    else if (weightKg < 84) i = 2;
    else if (weightKg < 98) i = 3;
    else i = 4;
    if (heightCm) {
      if (heightCm >= 188) i += 1;
      else if (heightCm <= 166) i -= 1;
    }
    i = Math.max(0, Math.min(SIZES.length - 1, i));
    return SIZES[i];
  }

  function savedMeasures() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      var h = parseFloat(d.height);
      var w = parseFloat(d.weight);
      if (!h && !w) return null;
      return { height: h || 0, weight: w || 0 };
    } catch (e) {
      return null;
    }
  }

  function saveMeasures(heightCm, weightKg) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ height: heightCm, weight: weightKg }));
    } catch (e) {}
  }

  function describeDelta(mine, model) {
    var bits = [];
    if (mine.height && model.height) {
      var dh = Math.round(mine.height - model.height);
      if (Math.abs(dh) <= 2) bits.push('praticamente a mesma altura');
      else bits.push('o modelo é ' + Math.abs(dh) + ' cm mais ' + (dh > 0 ? 'baixo' : 'alto') + ' que você');
    }
    if (mine.weight && model.weight) {
      var dw = Math.round(mine.weight - model.weight);
      if (Math.abs(dw) <= 2) bits.push('praticamente o mesmo peso');
      else bits.push(Math.abs(dw) + ' kg mais ' + (dw > 0 ? 'leve' : 'pesado'));
    }
    return bits.join(' e ');
  }

  function initModal() {
    var modal = document.getElementById('fit-modal');
    if (!modal || modal._hmyInit) return;
    modal._hmyInit = true;

    var matchBox = document.getElementById('fit-match');
    var matchLabel = document.getElementById('fit-match-label');
    var matchText = document.getElementById('fit-match-text');
    var matchSize = document.getElementById('fit-match-size');
    var form = document.getElementById('fit-measure-form');

    var model = {
      height: parseFloat(matchBox.getAttribute('data-model-height')) || 0,
      weight: parseFloat(matchBox.getAttribute('data-model-weight')) || 0,
      wears: matchBox.getAttribute('data-model-wears') || ''
    };

    function renderMatch() {
      var mine = savedMeasures();
      if (!mine) {
        matchBox.classList.add('muted');
        matchLabel.textContent = 'SEU CAIMENTO';
        matchSize.hidden = true;
        return;
      }
      var rec = recommend(mine.height, mine.weight);
      matchBox.classList.remove('muted');
      matchLabel.textContent = 'SEU CAIMENTO — ' + fmtHeight(mine.height) + ' / ' + (mine.weight ? mine.weight + ' kg' : '— kg');
      var delta = describeDelta(mine, model);
      var phrase = model.wears
        ? (delta ? 'Comparando: ' + delta + '. ' : '') + 'O modelo veste ' + model.wears + '.'
        : (delta ? 'Comparando: ' + delta + '.' : '');
      if (rec && model.wears && rec !== model.wears) {
        phrase += ' Para o seu corpo, a indicação muda:';
      } else if (rec && model.wears) {
        phrase += ' Para o seu corpo, a indicação é a mesma:';
      } else if (rec) {
        phrase += ' Pra você, a indicação é:';
      }
      matchText.textContent = phrase;
      if (rec) {
        matchSize.textContent = 'TAMANHO ' + rec;
        matchSize.hidden = false;
      } else {
        matchSize.hidden = true;
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var h = parseFloat(document.getElementById('fit-input-height').value) || 0;
        var w = parseFloat(document.getElementById('fit-input-weight').value) || 0;
        if (!h && !w) return;
        saveMeasures(h, w);
        renderMatch();
      });
    }

    function open() {
      renderMatch();
      modal.classList.add('open');
    }
    function close() {
      modal.classList.remove('open');
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('#fit-bubble') || e.target.closest('.hmy-fit-trigger-btn')) open();
    });
    var closeBtn = document.getElementById('fit-close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });

    var toChart = document.getElementById('fit-to-sizechart');
    if (toChart) {
      toChart.addEventListener('click', function () {
        close();
        var sm = document.getElementById('size-modal');
        if (sm) sm.classList.add('open');
      });
    }

    renderMatch();
  }

  document.addEventListener('DOMContentLoaded', initModal);
  document.addEventListener('shopify:section:load', initModal);

  return { recommend: recommend, savedMeasures: savedMeasures, SIZES: SIZES };
})();
